export default "__VITE_ASSET__84abb92b__"